import { emitCustomEvent } from 'react-custom-events'

/**
 * Close whatever modal is currently open.
 */
export const closeModal = () => {
  emitCustomEvent('CLOSE_GLOBAL_MODAL')
}

/**
 * Show a confirmation/alert modal (Figma 209-5177 "modal" type).
 * Centered title + centered description + flush buttons.
 *
 * @param {string} message  - Plain text or HTML string
 * @param {Array}  buttons  - [{title, callback}] — first = confirm, second = cancel
 * @param {object|boolean} options - { title, type, isWide } or legacy boolean isWide
 */
export const showModal = (message, buttons, options = {}) => {
  const opts = typeof options === 'boolean' ? { isWide: options } : options
  emitCustomEvent('SHOW_GLOBAL_MODAL', { message, buttons: buttons || [], type: 'modal', ...opts })
}

/**
 * Show an information alert (Figma 209-5177 "information" type).
 * Info icon + left-aligned title + left-aligned description + flush buttons.
 *
 * @param {string} title    - Alert heading
 * @param {string} message  - Plain text or HTML string
 * @param {Array}  buttons  - [{title, callback}] — first = confirm, second = cancel
 */
export const showInfoModal = (title, message, buttons) => {
  emitCustomEvent('SHOW_GLOBAL_MODAL', { title, message, buttons: buttons || [], type: 'information' })
}

/**
 * Show a modal with arbitrary JSX content and a close button.
 * The render function receives a close() callback.
 *
 * @param {function} render - (close) => JSX
 */
export const showContentModal = (render) => {
  emitCustomEvent('SHOW_GLOBAL_CONTENT_MODAL', render)
}
